import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BlueprintDeployment,
  BlueprintVersionedGroup,
  BlueprintVersionedGroupCompatibleVersionsArgs,
  MutationBlueprintDeploymentUpdateArgs,
} from "types/generated";

type UpdateDeploymentData = {
  blueprintDeploymentUpdate: Pick<BlueprintDeployment, "id" | "name" | "blueprintVersion">;
};

export const UPDATE_DEPLOYMENT: TypedDocumentNode<
  UpdateDeploymentData,
  MutationBlueprintDeploymentUpdateArgs
> = gql`
  mutation BlueprintDeploymentUpdate(
    $blueprintID: ID!
    $id: ID!
    $input: BlueprintDeploymentUpdateInput!
  ) {
    blueprintDeploymentUpdate(blueprintID: $blueprintID, id: $id, input: $input) {
      id
      name
      blueprintVersion {
        id
        version
      }
    }
  }
`;

type GetCompatibleVersionsData = {
  blueprintVersionedGroup: Pick<BlueprintVersionedGroup, "id" | "compatibleVersions">;
};

export const GET_COMPATIBLE_VERSIONS: TypedDocumentNode<
  GetCompatibleVersionsData,
  { id: string } & BlueprintVersionedGroupCompatibleVersionsArgs
> = gql`
  query GetCompatibleVersions($id: ID!, $versionId: ID!) {
    blueprintVersionedGroup(id: $id) {
      id
      compatibleVersions(versionId: $versionId) {
        id
        version
        state
        updatedAt
      }
    }
  }
`;
